import {createBackendEditor, referenceActionData} from '../../form/ComponentEditor';
import OperationListEditor from './OperationListEditor';
import {CurrencyFormatter, ProductColumn, UnitFormatter} from "../../../utils/formatters";
import {postData} from "../../../utils/request";
import React, {Fragment} from "react";
import TextInput from "../../form/TextInput";
import {ifCompletedInput} from "../../../utils/other";
import isEqual from 'lodash-es/isEqual';
import Button from "../../form/Button";
import InventoryForm from "./Elements/InventoryForm";
import {PriceView} from "../../classes/Price";
import Modal from "../../layout/Modal";
import Box from "../../layout/Box";
import connect from "react-redux/es/connect/connect";

const sortable = true;
const filterable = true;

class InventoryEditor extends React.Component {

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.values[this.props.componentConfig.idfield] !== prevProps.values[prevProps.componentConfig.idfield]) {
            this.setState({partly: false, full: false});
        }
    }

    state = {
        partly: false,
        full: false,
        check: false,
        componentEditor: "Inventory",
        filter: [
            {column: "preset", value: "Inventory"},
            {column: "saved", value: 1}
        ],
        labels: {customer: "Partner", source: "Raktár"},
        actionButtons: [],
        pool: {
            orderBy: {field: "displayname", direction: "ASC"},
            visible: false,
            selection: [],
            pageSize: 10,
            pageSizes: [5,10,15,20,50],
            aggregations: {
                fields: {
                    "count": {
                        field: "pickedqty", type: "COUNT"
                    },
                    "pickedqty": {
                        field: "pickedqty", type: "SUM"
                    },
                }
            },
            component: "OperationProductPoolItem",
            view: ["id","product_id","OperationList_id", "vat", "component_type", "component_id", ...PriceView("saleprice"), "saleprice", ...PriceView("listprice"), "listprice"],
            columns: {
                "displayname": {
                    ...ProductColumn("component_id"),
                    width: 1,
                },
                "tradename.name": {
                    header: 'Kiadó',
                    width: 1,
                    sortable,
                    filterable,
                },
                "barcode": {
                    header: 'Vonalkód',
                    width: 1,
                    sortable,
                    filterable
                },
                "listprice": {
                    header: 'Lista ár',
                    width: 1,
                    sortable,
                    filterable,
                    renderer: CurrencyFormatter
                },
                "stockqty": {
                    header: 'Raktárkészlet',
                    width: 1,
                    sortable,
                    filterable,
                    renderer: (value, row) => UnitFormatter(value, row.unit),
                    className: "unit"
                },
                "pickedqty": {
                    header: "Darabszám",
                    width: 1,
                    renderer: (value, row) => UnitFormatter(value, row.unit),
                    sortable,
                    filterable,
                    aggregation: (value, row) => {
                        return <Fragment><span className="unit">Összesen: {UnitFormatter(row.pickedqty || 0, row.unit).props.children}</span><span className="unit">Tétel: {UnitFormatter(row.count || 0, row.unit).props.children}</span></Fragment>;
                    },
                    className: "unit",
                    editor:
                        (parent) =>
                            (props, value) =>
                                <TextInput type="number" name="pickedqty" label={false} focus value={value}
                                           onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value);}}
                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                },
            }
        }
    };

    formatOperationItems = (config) => {
        config.pageSize = 5;
        config.actions = true;
        return config;
    }

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve()
            });
        });
    }

    constructor(props) {
        super(props);
    }

    setFieldValue = (field, value) => {
        this.props.setFieldValue(field, value);
        if (field === "customer" && !isEqual(value, this.props.values.customer)) {
            this.props.setFieldValue("target", null);
        }
    }

    getProps = () => {
        const props = {
            ...this.props,
            ...this.state,
            setFieldValue: this.setFieldValue,
        };
        if (!this.props.user.hasPermission("change_inventory")) {
            props.actionButtons = [
                <Fragment key="6">
                    {!this.props.user.hasPermission("change_inventory") &&
                    <Button
                        key="6"
                        disabled={props.isLoading || !props.values.id || !props.values.source}
                        color="default"
                        className="pull-right"
                        onClick={async () => {
                            this.setState({check: !this.state.check});
                        }}
                    >
                        Eltérések {this.state.check ? "bezárása" : "ellenőrzése"}
                    </Button>
                    }
                </Fragment>,
                <Fragment key="4">
                    <Modal
                        header="Biztos?"
                        state={this.state.partly}
                        size="small"
                        buttons={[
                            {
                                text: 'Mégse',
                                props: {
                                    color: "default",
                                    disabled: this.props.disabled || this.props.isLoading || this.state.loading
                                },
                                onClose: true,
                                onClick: async () => {
                                    try {
                                        this.setState({partly: false});
                                    } catch (e) {

                                    }
                                }
                            },
                            {
                                text: 'Igen, ezt akarom!',
                                props: {
                                    color: "danger",
                                    disabled: this.props.disabled || this.props.isLoading || this.state.loading
                                },
                                onClose: true,
                                onClick: async () => {
                                    try {
                                        const values = props.values;
                                        values.autocheckup = true;
                                        await props.processAction(async () => {
                                            const response = await postData({
                                                action: 'OperationList.doAction',
                                                actionname: 'create',
                                                type: 'partly',
                                                data: await referenceActionData(values, this.props.componentConfig)
                                            });
                                            await this.props.pristineForm(false);
                                            return response;
                                        });
                                        this.setState({partly: false});
                                    } catch (e) {

                                    }
                                }
                            },
                        ]}
                    >
                        A részleges leltár esetén a listán szereplő termékek kerülne csak leltárazásra!<br/>
                        Biztos ezt akarod?
                    </Modal>
                    {this.state.check && <Button
                        key="4"
                        privileges={["close_inventory"]}
                        disabled={props.isLoading || !props.values.id}
                        color="primary"
                        icon={{lib: "fa", name: "box"}}
                        className="pull-right"
                        onClick={async () => {
                            this.setState({partly: true});
                        }}
                    >
                        Részleges leltár
                    </Button>}
                </Fragment>,
                <Fragment key="5">
                    <Modal
                        header="Biztos?"
                        state={this.state.full}
                        size="small"
                        buttons={[
                            {
                                text: 'Mégse',
                                props: {
                                    color: "default",
                                    disabled: this.props.disabled || this.props.isLoading || this.state.loading
                                },
                                onClose: true,
                                onClick: async () => {
                                    try {
                                        this.setState({full: false});
                                    } catch (e) {

                                    }
                                }
                            },
                            {
                                text: 'Igen, ezt akarom!',
                                props: {
                                    color: "danger",
                                    disabled: this.props.disabled || this.props.isLoading || this.state.loading
                                },
                                onClose: true,
                                onClick: async () => {
                                    try {
                                        const values = props.values;
                                        values.autocheckup = true;
                                        await props.processAction(async () => {
                                            const response = await postData({
                                                action: 'OperationList.doAction',
                                                actionname: 'create',
                                                type: 'full',
                                                data: await referenceActionData(values, this.props.componentConfig)
                                            });
                                            await this.props.pristineForm(false);
                                            return response;
                                        });
                                        this.setState({full: false});
                                    } catch (e) {

                                    }
                                }
                            },
                        ]}
                    >
                        A teljes leltár esetén a listára felnem vett termékek is leltárazásra kerülnek!<br/>
                        Biztos ezt akarod?
                    </Modal>
                    {this.state.check && <Button
                        key="5"
                        privileges={["close_inventory"]}
                        disabled={props.isLoading || !props.values.id}
                        color="danger"
                        icon={{lib: "fa", name: "boxes"}}
                        className="pull-right"
                        onClick={async () => {
                            this.setState({full: true});
                        }}
                    >
                        Teljes leltár
                    </Button>}
                </Fragment>
            ];
        } else {
            props.actionButtons = [
                <Button
                    key="5"
                    privileges={["close_inventory"]}
                    disabled={props.isLoading || !props.values.id}
                    color="danger"
                    icon={{lib: "fa", name: "boxes"}}
                    className="pull-right"
                    onClick={async () => {
                        try {
                            const values = props.values;
                            values.autocheckup = true;
                            await props.processAction(async () => {
                                const response = await postData({
                                    action: 'OperationList.doAction',
                                    actionname: 'create',
                                    type: 'full',
                                    data: await referenceActionData(values, this.props.componentConfig)
                                });
                                await this.props.pristineForm(false);
                                return response;
                            });
                            this.setState({full: false});
                        } catch (e) {

                        }
                    }}
                >
                    Lezárás
                </Button>
            ];
        }
        props.pool.parameters = {};
        props.pool.reqparams = {};
        if (this.props.till.pos.location && !this.props.user.hasPermission("change_inventory")) {
            props.filter = [...props.filter, {field: "source", value: this.props.till.pos.location.id}];
        }
        if (props.values && props.values.source) {
            props.pool.visible = true;
            props.pool.parameters.partner = props.values.source.partner.partner_id;
            props.pool.parameters.store_partner = props.values.source.partner.partner_id;
            props.pool.parameters.accountdate = props.values.accountdate;
            props.pool.parameters.store = props.values.source.id;
            props.pool.parameters.OperationList_id = props.values.id;
        } else {
            props.pool.visible = false;
        }
        return props;
    }

    renderer = (componentProps) => {
        if (!((this.props.till || {}).pos || {}).id) {
            return <Box header="Hiba" theme="danger">
                Kérlek jelentkezz be egy eladási helyre!
            </Box>;
        }
        return <InventoryForm {...this.props} {...componentProps} check={this.state.check} swapCheck={() => this.setState({check: !this.state.check})} />;
    }

    render() {
        const props = this.getProps();
        return <OperationListEditor {...props} renderer={this.renderer} formatOperationItems={this.formatOperationItems} />;
    }

}

export default connect((state) => {
    return {
        till: state.app.till,
        user: state.app.user
    };
}, {})(createBackendEditor({
    componentName: "OperationList",
    WrappedComponent: InventoryEditor,
    editor: "Inventory",
    dirtyFlag: (values) => {
        return !parseInt(values.saved) && values.id;
    },
    props: {
        componentActions: async (action, data, params, componentConfig) => {
            params.preset = "Inventory";
            data = await referenceActionData(data, componentConfig);
            return {action,data,params};
        }
    }
}));